































import { Vue, Component } from 'vue-property-decorator';
import MainLayout from '@/layouts/main.vue';
import Navigation from '@/modules/navigation/components/navigation/navigation.vue';
import GlobalMessages from '@//modules/messaging/components/global-messages/global-messages.vue';
import TwoColumnsLayout from '@/layouts/two-columns.vue';
import sidebarMutations from '@/store/global/mutation-types';
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapSidebarState, mapMutations: mapSidebarMutations } = createNamespacedHelpers('global');
const { mapActions: mapNavigationActions } = createNamespacedHelpers('navigation');
const { mapActions: mapVersionsActions } = createNamespacedHelpers('versions');
const { mapActions: mapFeaturesActions } = createNamespacedHelpers('features');

@Component({
    components: {
        'main-layout': MainLayout,
        'global-messages': GlobalMessages,
        'two-columns-layout': TwoColumnsLayout,
        navigation: Navigation
    },

    beforeMount() {
        this.getFeatures();
        this.getNavigation();
        this.getVersions();
    },

    computed: {
        ...mapSidebarState(['isMobileVisible'])
    },

    methods: {
        ...mapSidebarMutations({
            toggleSidebar: sidebarMutations.TOGGLE_SIDEBAR_VISIBILITY
        }),
        ...mapNavigationActions(['getNavigation']),
        ...mapVersionsActions(['getVersions']),
        ...mapFeaturesActions(['getFeatures'])
    }
})
export default class IndexPage extends Vue {}
